"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.topicClusters = topicClusters;
exports.topicClustersRequestState = topicClustersRequestState;

var _TopicClusters = require("lead-flows-ui/actions/TopicClusters");

var _RequestState = require("lead-flows-ui/utils/RequestState");

var DEFAULT_STATE = {
  results: []
};

function topicClusters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _TopicClusters.ADD_TOPIC_CLUSTERS:
      return {
        results: action.topicClusters
      };

    default:
      return state;
  }
}

function topicClustersRequestState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _RequestState.NOT_REQUESTED;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _TopicClusters.SET_TOPIC_CLUSTERS_REQUEST_STATE:
      return action.requestState;

    default:
      return state;
  }
}